export default "__VITE_ASSET__28df54be__"